import {Component, Input, OnInit} from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {Pagination} from "@core/bean/pagination";
import {NzModalService} from "ng-zorro-antd";
import {BrowseConfig} from "@core/bean/browse-config";
import {CommonsService} from "@core/service/commons.service";
import {SupplyTypeService} from "../../../../routes/jy-srm/basic-data/srm-supply-type/supply-type/supply-type.service";
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";

@Component({
  selector: 'app-company',
  templateUrl: './supplyType.component.html',
  styles: []
})
export class SupplyTypeComponent implements BrowseComponent, OnInit {

  static componentName = 'SupplyTypeBrowseComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  formLoading = false;
  pagination: Pagination = new Pagination();
  searchData: any = {};

  constructor(private commonsService: CommonsService,
              private modalService: NzModalService,
              private supplyTypeService: SupplyTypeService
  ) {
    this.pagination.getData = function (params: HttpParams): Observable<any> {
      return supplyTypeService.query(params);
    }
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

}
